export function normalizePeakRate(timeSeries, type) {
  try {
    if (!timeSeries || !type) return;

    console.log(`Normalizing ${type} by peak rate...`);

    let newTimeSeries = {byFluid: {}, fluids: []};

    Object.keys(timeSeries?.byFluid)?.forEach(fluid => {

      // find max production
      let maxProduction = {
        value: 0,
        index: 0,
        monthsOnline: 0,
        date: null
      };

      timeSeries?.byFluid?.[fluid]?.forEach((f,i) => {
        if (f) {
          const volume = ((type === 'production' ? f?.volume : f?.volume?.p50) || 0);
          if (volume > maxProduction.value) {
            maxProduction.value = volume;
            maxProduction.index = i;
            maxProduction.monthsOnline = f.monthsOnline;
            maxProduction.date = f.date;
          };
        };
      });

      // shift months online
      let fluidTimeSeries = [];
      timeSeries?.byFluid?.[fluid]?.forEach((f, i) => {
        if (f) {
          let initialTotal = 0;
          if (i < maxProduction.index) {
            initialTotal += ((type === 'production' ? f?.volume : f.volume?.p50) || 0);
          } else {
            let cumVolume = {};
            if (type === 'production') {
              cumVolume = initialTotal + (f.cumVolume + 0);
            } else {
              f?.cumVolume && Object.keys(f?.cumVolume)?.forEach(prob => {
                cumVolume[prob] = initialTotal + (f?.cumVolume[prob] || 0);
              });
            };
            const newMonthsOnline = f?.monthsOnline - (maxProduction.monthsOnline - 1);

            fluidTimeSeries.push({...f, cumVolume: cumVolume, monthsOnline: newMonthsOnline});
          };
        };
      });

      newTimeSeries.byFluid[fluid] = fluidTimeSeries;
      if (newTimeSeries.fluids.indexOf(fluid) === -1) newTimeSeries.fluids.push(fluid);
    });


    return newTimeSeries;
  } catch (error) {
    console.error(error);
    return timeSeries;
  };
};